import { FC } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { useTHelper } from 'src/utils/i18n';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { BaseSeparateModal } from 'src/models/modals';
import { PlusSubscriptionPlusIcon } from 'src/components/plusSubscription/modals/icons/Plus';
import { UiButton } from 'src/components/UI/Button';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { PlusSubscriptionUpgradeNowModalClose } from 'src/components/plusSubscription/modals/icons/Close';
import { PlusSubscriptionLogo } from 'src/components/plusSubscription/modals/icons/Logo';
import styles from './styles.module.scss';

type Props = BaseSeparateModal & {
  onContactUsClick: () => void;
  showHeader: boolean;
};

export const UpsellUpgradeNowModal: FC<Props> = ({ onClose, onContactUsClick, showHeader }) => {
  const tHelper = useTHelper('upsellModals.upgradeNow');

  const featuresLocales = ['volumePricing', 'dedicatedFundraisingSpecialist'];

  const { EnableChatWidget, ContactEmail } = useSelector(deCommonCurrentPartnerSelector);

  return (
    <UiModal noFooter onHide={onClose} modalClassName={styles.modal}>
      {showHeader ? (
        <div className={classNames(styles.header)}>
          <button type="button" onClick={onClose} className={styles.close}>
            <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
          </button>

          <PlusSubscriptionLogo className={styles.logo} />
        </div>
      ) : (
        <button type="button" onClick={onClose} className={styles.close}>
          <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
        </button>
      )}

      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <div className={styles.title}>{tHelper('title')}</div>
          <div className={styles.description}>{tHelper('description')}</div>
        </div>

        <div className={styles.features}>
          {featuresLocales.map((item) => (
            <div key={item} className={styles.item}>
              <PlusSubscriptionPlusIcon className={styles.icon} />
              <div className={styles.caption}>{tHelper(`features.${item}.caption`)}</div>
              <div className={styles.description}>{tHelper(`features.${item}.description`)}</div>
            </div>
          ))}
        </div>

        <div className={styles.buttonsWrapper}>
          {EnableChatWidget ? (
            <UiButton effects className={styles.btn} onClick={onContactUsClick}>
              {tHelper('contactUs')}
            </UiButton>
          ) : (
            <UiInnerNotSPALink className={`btn waves-effect waves-light ${styles.btn}`} href={`mailto:${ContactEmail}`}>
              {tHelper('contactUs')}
            </UiInnerNotSPALink>
          )}
        </div>
      </div>
    </UiModal>
  );
};
